import { render, staticRenderFns } from "./CompanyDepartmentDetail.vue?vue&type=template&id=808cd94c&scoped=true&"
import script from "./CompanyDepartmentDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyDepartmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDepartmentDetail.vue?vue&type=style&index=0&id=808cd94c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808cd94c",
  null
  
)

export default component.exports